import router from '@/router/index.js';
import store from '@/store';
import { systemSetup, login } from '@/api';
import { getSession, setSession, getCookieValue } from '@/utils';
import authorityRouter from './routes/authorityRouter';
// 一些其它方法
import { getBrandList } from './routerEvent';
// 本地配置菜单
import dataTest from '@/views/Layout/demoData';

// 是否已经获取过品牌列表
var isGetBrandList = false;
// 原本要跳转去的路径
var oldUrlTo = null;

// 遍历权限路由
const addAuthMenuRouter = (menu, callback) => {
  // console.log('遍历权限路由', menu);
  // 遍历所有路由，获取二级路由
  let topMenuList = []; // 顶部菜单
  let indieApps = []; // 独立应用
  let parent = []; // 一级菜单
  // let childrenObj = {};
  let oneChild = []; // 二级菜单key值
  let children = []; // 页面菜单
  let buttonLis = []; // 按钮权限
  const flatten = arr => arr.reduce((flat, next) => {
    // console.log('遍历所有的菜单权限', flat, next);
    if ([1, 2, 4].indexOf(next.typeCode) > -1) {
      if (next.typeCode === 1) {
        // 顶部菜单
        topMenuList.push(next);
      } else if (next.typeCode === 2) {
        // 独立应用
        indieApps.push(next);
      } else if (next.typeCode === 4) {
        oneChild.push(next.menuKey);
      };
      if (Array.isArray(next.subMenus) && next.subMenus.length > 0) {
        return flat.concat(flatten(next.subMenus));
      } else {
        return flat;
      }
    } else {
      if (next.typeCode === 3) {
      // 一级菜单
        parent.push(next.menuKey);
      } else if (next.typeCode === 5) {
        let menuK = next.menuKey.indexOf('_') > -1 ? next.menuKey.split('_')[1] : next.menuKey;
        children.push(menuK);
      } else if (next.typeCode === 6) {
        buttonLis.push(next.menuKey);
      }
      // 遍历出所有的权限
      if (Array.isArray(next.subMenus) && next.subMenus.length > 0) {
        return flat.concat(next.menuKey, flatten(next.subMenus));
      } else {
        return flat.concat(next.menuKey);
      }
    }
  }, []);
  flatten(menu); // 这里返回了所有的菜单和按钮权限
  // console.log('我要从我现有的路由中找到我有权限的路由：', authorityRouter, 886, parent, 996, oneChild, children);
  // debugger;
  addAuthMenu(parent, oneChild, children, callback);
  // 储存session，供权限按钮使用
  setSession('navSecondList', JSON.stringify(children));
  setSession('navOneList', JSON.stringify(oneChild));
  setSession('btnAuthList', JSON.stringify(buttonLis));
  // 顶部菜单权限
  store.dispatch('user/setTopMenuList', topMenuList);
  // 独立应用
  store.dispatch('user/setIndieApps', indieApps);
};

// 添加权限路由至项目中
const addAuthMenu = (p, onwC, twoC, callback) => {
  let authList = [];
  // 遍历一级路由
  p.forEach((pItem, pIndex) => {
    let item = authorityRouter.find((n) => n.name === pItem);
    if (item) {
      let child = [];
      // 遍历子菜单
      item.children.forEach((e, i) => {
        let chilItem = onwC.find((n) => n === e.name);
        let insidePage = onwC.find((n) => n === e.meta.insidePageFrom);
        if (chilItem) {

          child.push(e);

        } if (insidePage) {

          // 详情页，编辑添加页
          let insideChild = [];
          let insideItem = e;
          insideItem.children.forEach((ee, ii) => {
            let inlineChild = twoC.find((n) => n === ee.name);
            if (inlineChild) {
              insideChild.push(ee);
            }
          });
          if (insideChild.length > 0) {
            insideItem.children = [].concat(insideChild);
            child.push(insideItem);
          };

        }
      });
      item.children = [].concat(child);
      authList.push(item);
    }
  });
  // console.log(router, '全部的权限路由：', authList);
  if (router) {
    router.addRoutes(authList);
  } else {
    let maxTimer = 20000;
    let initTimer = 0;
    let forTimer = setInterval(() => {
      if (router) {
        clearInterval(forTimer);
        router.addRoutes(authList);
      } else if (initTimer > maxTimer) {
        clearInterval(forTimer);
      }
      initTimer += 60;
    }, 60);
  };
  setSession('routeMenu', authList);
  store.dispatch('user/setIsAuthMenu', true);
  // 回调
  // console.log('菜单更新完毕99999999999', oldUrlTo);
  // debugger;
  // 如果是直接跳进内页的，查看是否具有改内页的权限，有就可以直接跳，没有的话，则跳到首页
  if (oldUrlTo && (!oldUrlTo.name || oldUrlTo.redirectedFrom)) {
    if (callback) callback(oldUrlTo.redirectedFrom || oldUrlTo.path);
  } else {
    let toUrlItem = '/home';
    if (callback) callback(toUrlItem);
  }
};

// 获取用户信息
const getUserInfo = (callback) => {
  // console.log('获取用户信息333333333333', isGetBrandList);
  return new Promise((resolve, reject) => {
    if (isGetBrandList) return true;
    isGetBrandList = true;
    // 测试
    // getBrandList(callback, resolve);

    login.isLoginFlag().then(res => {
      if (res.code === 0) {
        // console.log('获取用户信息isLoginFlag555:', res);
        getBrandList(callback, resolve);
        // 存session，用户信息
        if (res.data) {
          var l = res.data.list;
          store.dispatch('user/setCurrentUser', res.data.accountInfo);
          if (l && l.length > 0) {
            let teamId = l[l.length - 1].id;
            document.cookie = 'teamId=' + teamId;
            setSession('teamId', teamId);
            setSession('teamIdList', l);
          } else {
            resolve(false);
          }
        };
        // 是否已经储存了token，并且将当前的token变成现登录的token
        if (getCookieValue('cmms2_token') &&
        (!getSession('cmms2Token') || (getSession('cmms2Token') && (getSession('cmms2Token') !== getCookieValue('cmms2_token'))))) {
          setSession('cmms2Token', getCookieValue('cmms2_token'));
        }
      } else {
        resolve(false);
      }
    }).catch(() => {
      resolve(false);
    });
  });
};

/* 逻辑：当缓存了权限菜单，直接读取权限菜单；未缓存则请求
  遍历请求过来的权限菜单，从本地路由中抽出有权限的菜单，添加进路由
*/
// isFromOnlyLogin：是否从单点登录过来
// to：需要去哪个路由
// fromType：从哪里调用的这个方法; 1 index.js 路由的正常登陆、
//           3 main.js 刷新的时候 、4 顶部更改品牌、 5、 system用户设置里面 用户修改自己的权限组、
//           6 system 新建权限组的时候、 7 index.js 路由 走单点登录
//           8 账号编辑的时候，编辑自己的账号，导致权限有变
const addFun = async(option, isFromOnlyLogin, to, fromType) => {
  oldUrlTo = null;
  // console.log(getSession('isHadSetMenu'), '是否从单点登录过来', fromType, store.getters['user/isHadSetMenu'], '洛索洛芬交多少', getSession('authMenuList'), isFromOnlyLogin, '路由是：', router && router.currentRoute && router.currentRoute.path);
  // debugger;
  // 已经添加过权限路由
  if (getSession('isHadSetMenu') && store.getters['user/isHadSetMenu']) {
    // console.log('已经添加过权限路由88888888888888');
    // 回调
    if (option.callback) option.callback();
    return;
  }

  // 获取所有权限
  if (getSession('authMenuList')) {
    // console.log('获取所有权限9999999999999');
    // 添加路由
    addAuthMenuRouter(getSession('authMenuList'), option.callback);
  } else {
    console.log('如果从单点登录过来，则请求登录数据1111111111111111', isFromOnlyLogin, store.getters['user/user'], getSession('user'));
    if (isFromOnlyLogin) {
      // 如果从单点登录过来，则请求登录数据 begin
      // console.log(to, '如果从单点登录过来，则请求登录数据222222222222222', to.redirectedFrom);
      if (to && getCookieValue('cmms2_token')) {
        oldUrlTo = to;
      }
      let isLogin = await getUserInfo(option.callback);
      isGetBrandList = false;
      // console.log('如果从单点登录过来，则请求登录数据:', isLogin, 999);
      if (!isLogin) {
        // debugger;
        // 回调,如果单点登录证实是没有登录的，则跳去登录页
        if (option.callback) option.callback('/login');
        return;
      };
      // 如果从单点登录过来，则请求登录数据 end
    } else if (!store.getters['user/user'] || !getSession('user')) {
      // 如果切换了登录用户，或者用户信息不存在，请求用户信息
      let isLogin = await getUserInfo(option.callback);
      isGetBrandList = false;
      if (!isLogin) {
        // 回调
        if (option.callback) option.callback();
        return;
      };
    };

    var getBrandTimer;
    if (getBrandTimer) clearInterval(getBrandTimer);
    // 必须有brand才能请求权限菜单
    // 用户每次只能看一个品牌的页面，可以切换品牌
    var getBrandtime = 0;
    getBrandTimer = setInterval(() => {
      // console.log('请求菜单newMenuListByUser', store.getters['user/brand']);
      if (store.getters['user/brand']) {
        clearInterval(getBrandTimer);
        // console.log('请求了一次权限餐单：', store.getters['user/brand'], '倒计时：', getBrandTimer);
        if (store.getters['user/isGetAuthList']) return;
        store.dispatch('user/flagGetAuthList', true);

        let pm = {
          brand: store.getters['user/brand']
        };
        systemSetup.newMenuListByUser(pm).then(res => {
          // console.log('用户每次只能看一个品牌的页面，可以切换品牌', store.getters['user/brand'], option.callback);
          // debugger;
          if (res.code === 0 && res.data) {

            if (process.env.ENV_CONFIG === 'dev') {
              // 开发环境默认使用本地的菜单配置
              res.data = dataTest.allMenu;
              // console.log(dataTest.allMenu, '开发环境默认使用本地的菜单配置');
            };

            // 储存
            setSession('authMenuList', res.data);
            // 添加路由
            addAuthMenuRouter(res.data, option.callback);
            store.dispatch('user/flagGetAuthList', false);
          } else {
            if (res.msg && !store.getters['user/isHadSetMenu']) {
              // this.$gcErrorMsg(res.msg);
              console.log(res.msg, '2222请求菜单出错了！！！');
            };

            // 获取权限菜单失败，也是设置完了菜单，这时候是菜单只有基础菜单\
            store.dispatch('user/setIsAuthMenu', true);
            if (option.callback) option.callback();
          };
        });
      } else if (getBrandtime >= 100000) {
        clearInterval(getBrandTimer);
      } else {
        getBrandtime += 1000;
      }
    }, 100);

  }

};

export default addFun;
